import { type AppBase } from 'playcanvas';

// @engine/core — WarmupRunner (REBUILD_PLAN Step 7a). Relocated VERBATIM from
// packages/client/src/app/resilience.ts (the warmup function only; ContextLossGuard imports this).

/**
 * Shader warmup contract (arch §2.7.1, perf §4.4). In this build every material is created at scene-build time
 * and rendered on the first frame, and the QualityLadder does NOT yet toggle keyword sets at runtime — so the
 * reachable program set is FROZEN by construction and no program compiles mid-session. Forcing one render here
 * guarantees the first VISIBLE frame is already compiled. The `< 30 programs` gate is asserted by the perf
 * probe (currently 5). When the runtime QualityLadder lands (M5), this becomes a tier-exhaustive hidden-render.
 */
export function warmup(app: AppBase): void {
  app.render();
}
